import { action } from './';

export const SHOW_SQUAD_MODAL = 'SHOW_SQUAD_MODAL';
export const HIDE_SQUAD_MODAL = 'HIDE_SQUAD_MODAL';

export const showSquadModal = squad => action(SHOW_SQUAD_MODAL, { squad });
export const hideSquadModal = () => action(HIDE_SQUAD_MODAL);



// WEBPACK FOOTER //
// ./src/actions/squad.js